import {Component, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {AuthState} from '../../store/auth/auth.reducer';
import {CallBackAfterRegistrationAction} from '../../store/auth/auth.actions';

@Component({
  standalone: false,
  selector: 'registration-auth-callback',
  template: ``,
  styleUrls: [],
})
export class RegistrationAuthCallbackComponent implements OnInit {

  constructor(private store: Store<{ authStateReducer: AuthState }>) { }

  ngOnInit() {
    this.store.dispatch(new CallBackAfterRegistrationAction());
  }

}